import React, { useEffect, useState } from 'react';
import styles from './CommunityRulesAdmin.module.css';
import { collection, query, orderBy, getDocs, addDoc, deleteDoc, updateDoc, doc } from 'firebase/firestore';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import { useNotifications } from "../../../utils/NotificationContext/NotificationContext";
import LightNav from "./../LightNav/LightNav";
import { useAuth } from "../../../utils/AuthContext/authcontext";
import { Navigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Button from '../../ui/Button';

export default function CommunityRulesAdmin() {
  const [rules, setRules] = useState([]);
    const { notify } = useNotifications();
  const { user, userData, claims } = useAuth(); 
  const { t } = useTranslation(); 

  const [form, setForm] = useState({
    title: '', body: '', order: 1
  });

  useEffect(() => {
    const fetchRules = async () => {
      const q = query(collection(firestore, 'communityRules'), orderBy('order'));
      const snap = await getDocs(q);
      setRules(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchRules();
  }, []);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleAdd = async () => {
    try {
      await addDoc(collection(firestore, 'communityRules'), {
        ...form,
        order: parseInt(form.order, 10)
      });
      notify('success', 'Rule added!');
      setForm({ title: '', body: '', order: 1 });
    } catch (err) {
      notify('error', err.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(firestore, 'communityRules', id));
      notify('success', 'Deleted');
    } catch (err) {
      notify('error', err.message);
    }
  };

  const handleUpdate = async (id, field, value) => {
    try {
      await updateDoc(doc(firestore, 'communityRules', id), {
        [field]: field === 'order' ? parseInt(value, 10) : value
      });
      notify('success', 'Updated!');
    } catch (err) {
      notify('error', err.message);
    }
  };

  if (!user || claims?.role !== 'admin') {
    return <Navigate to="/home" />;
  }

  return (
	<>
    <LightNav/>
    <div className={styles.container}>
      <h2>{t('admin.communityRulesTitle')}</h2>

      <div className={styles.form}>
        <input placeholder="Title" value={form.title} onChange={e => handleChange('title', e.target.value)} />
        <textarea placeholder="Body" value={form.body} onChange={e => handleChange('body', e.target.value)} />
        <input placeholder="Order" type="number" value={form.order} onChange={e => handleChange('order', e.target.value)} />
        <Button variant="primary" onClick={handleAdd}>{t('admin.addRule')}</Button>
      </div>

      <ul className={styles.list}>
        {rules.map(rule => (
          <li key={rule.id}>
            <input
              value={rule.title}
              onChange={e => handleUpdate(rule.id, 'title', e.target.value)}
              placeholder="Title"
            />
            <textarea
              value={rule.body}
              onChange={e => handleUpdate(rule.id, 'body', e.target.value)}
              placeholder="Body"
            />
            <input
              value={rule.order}
              type="number"
              onChange={e => handleUpdate(rule.id, 'order', e.target.value)}
              placeholder="Order"
            />
            <Button variant="secondary" onClick={() => handleDelete(rule.id)}>{t('admin.delete')}</Button>
          </li>
        ))}
      </ul>
    </div>
	</>
  );
}
